import { useSymbolsStore } from "../store/Symbols.js";
import { useSymbolsRender } from "../utils/useRender.js";
export var ValueQuote = props => {
  var {
    ValueQuote: Comp = {}
  } = useSymbolsStore();
  useSymbolsRender(Comp, props, 'ValueQuote');
  return null;
};
ValueQuote.displayName = 'JVR.ValueQuote';